require("packs/bookmarks")
require("packs/link_tracker")
require("packs/home_widget");
import "stylesheets/home.css";
import { initializeBannerSwiper, initializeStaticBannerClicks } from 'shared/banner_utils';

document.addEventListener("DOMContentLoaded", () => {
  // Initialize banner swiper if present
  initializeBannerSwiper('festival_page_swiper');

  initializeStaticBannerClicks();

  // Initialize event delegation for coupon cards (only once)
  initializeDescriptionToggleEventDelegation();
  initializeShareEventDelegation();

  initializeFestivalDescriptionToggle();
});

function initializeFestivalDescriptionToggle() {
  const toggleBtn = document.getElementById('festival-description-toggle');
  const textSpan = document.getElementById('festival-description-text');

  if (!toggleBtn || !textSpan) return;

  // Check if content is truncated (scrollHeight > clientHeight means overflow)
  if (textSpan.scrollHeight > textSpan.clientHeight) {
    toggleBtn.classList.remove('hidden');
    toggleBtn.classList.add('inline');
  }

  toggleBtn.addEventListener('click', function() {
    const isExpanded = this.dataset.expanded === 'true';

    if (isExpanded) {
      textSpan.classList.add('line-clamp-1');
      this.textContent = this.dataset.readMore;
      this.dataset.expanded = 'false';
    } else {
      textSpan.classList.remove('line-clamp-1');
      this.textContent = this.dataset.readLess;
      this.dataset.expanded = 'true';
    }
  });
}

// Initialize description toggle event delegation
// This function should only be called once on page load
function initializeDescriptionToggleEventDelegation() {
  let toggleDescContent = function (elem, status) {
    if (status == "open") {
      // Find the card container (parent grid element)
      let cardContainer = elem.closest('.card');
      if (cardContainer) {
        // Find the description content within the same card
        let descContent = cardContainer.querySelector('.desc-content');
        if (descContent) {
          // Hide the "Show More" button
          elem.classList.add('hidden');
          // Show the description content
          descContent.classList.remove('hidden');
        }
      }
    } else if (status == "close") {
      // Find the description content container
      let descContent = elem.closest('.desc-content');
      if (descContent) {
        // Find the card container
        let cardContainer = descContent.closest('.card');
        if (cardContainer) {
          // Find and show the "Show More" button again
          let moreInfoButton = cardContainer.querySelector(".desc-open-close");
          if (moreInfoButton) {
            moreInfoButton.classList.remove('hidden');
          }
          // Hide the description content
          descContent.classList.add('hidden');
        }
      }
    }
  };

  // Event delegation for description open buttons
  document.body.addEventListener("click", function(event) {
    const descOpenClose = event.target.closest(".desc-open-close");
    if (descOpenClose) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descOpenClose, "open");
    }
  });

  // Event delegation for description close buttons
  document.body.addEventListener("click", function(event) {
    const descLess = event.target.closest(".desc-less");
    if (descLess) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descLess, "close");
    }
  });
}

// Use event delegation for share icons and close buttons
// This function should only be called once on page load
function initializeShareEventDelegation() {
  // Event delegation for share icons
  document.body.addEventListener("click", function(event) {
    // Check if the clicked element is a shareIcon or inside one
    const shareIcon = event.target.closest(".shareIcon");
    if (shareIcon) {
      event.stopPropagation();
      let popupMenu = shareIcon.nextElementSibling;
      if (popupMenu && popupMenu.classList.contains('popupMenu')) {
        // Close all other open popups first
        document.querySelectorAll('.popupMenu').forEach(function(menu) {
          if (menu !== popupMenu && !menu.classList.contains('hidden')) {
            menu.classList.add('hidden');
          }
        });
        // Toggle the current popup
        popupMenu.classList.toggle("hidden");
      }
    }
  });

  // Event delegation for close buttons inside popups
  document.body.addEventListener("click", function(event) {
    const closeDiv = event.target.closest(".closediv");
    if (closeDiv) {
      event.stopPropagation();
      let popupMenu = closeDiv.closest('.popupMenu');
      if (popupMenu) {
        popupMenu.classList.add("hidden");
      }
    }
  });

  // Close popups when clicking outside
  document.body.addEventListener("click", function(event) {
    // If click is not on a popup menu or share icon, close all popups
    if (!event.target.closest('.popupMenu') && !event.target.closest('.shareIcon')) {
      document.querySelectorAll('.popupMenu').forEach(function(menu) {
        menu.classList.add('hidden');
      });
    }
  });
}

// Keep this function for backwards compatibility with show.js.erb AJAX calls
// With event delegation, this is now a no-op since events are already delegated
function setEventsForCouponCards() {
  // Event delegation handles all coupon card interactions automatically
}

window.setEventsForCouponCards = setEventsForCouponCards;
